import React, { useState } from 'react'
import ReactModal from 'react-modal'
import axios from 'axios'

import Cookies from 'universal-cookie';



function CambioContraseña(props) {


const cookie = new Cookies();
    const [modalIsOpen, setIsOpen] = useState(false);
    const handleOpenModalTest = () => {
        setIsOpen(true);
    };
    const closeModal = () => {
        setIsOpen(false);
    };   
    const [postContrasena, setPostContrasena] = useState([]);
    const postData = e => {
        e.preventDefault(e)
      if (postContrasena !== '') {
            axios({
                auth: { username: 'webapp', password: '762tsfsy9826kk87ytttsf' },
                method: 'put',
                url: 'https://educacionapi.azurewebsites.net/api/ActualizaUsuario?Id=' + cookie.get("id"),
                data: {
                    contrasena: postContrasena,
                }
            })
                .then((Response) => {
                    console.log(Response.data)
                    alert("Actualizado añadido con exito!")
                    window.location.reload("/")

                }).catch((error) => {
                    console.log(error)
                    alert("Error al crear" + error)
                })
        }

    };
    return (
        <div className="test">
            <button variant="contained" className='btn btn-warning' onClick={handleOpenModalTest} > cambio de contraseña</button>
            <ReactModal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Crear Institucion">


                <div className="container">
                    <div className="text-center">
                        <div class="container-fluid">
                            <div class="card shadow mb-4">
                                <div class="card-header py-3">
                                    <h6 class="m-0 font-weight-bold text-primary">Actualizar Contraseña</h6>
                                </div>
                                <div class="card-body">
                                    <div class="table-responsive"></div>
                                    <form className="user">
                                        <center>
                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                        <input type="password" className="form-control form-control-user" placeholder="Contraseña" onChange={(e) => setPostContrasena(e.target.value)} />
                                        </div>
                                        </center>
                                        <hr />
                                        <a ><button className="btn btn-primary btn-user btn-block " onClick={postData}>Guardar</button></a>


                                        <hr />
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal>

        </div>
    )
}
export default CambioContraseña;
